'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product7__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.pY;
      break;
    }
    case 1: {
      return $thiz.pZ;
      break;
    }
    case 2: {
      return $thiz.q0;
      break;
    }
    case 3: {
      return $thiz.q1;
      break;
    }
    case 4: {
      return $thiz.q2;
      break;
    }
    case 5: {
      return $thiz.q3;
      break;
    }
    case 6: {
      return $thiz.q4;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 6)"));
    }
  }
}
export { $f_s_Product7__productElement__I__O as $f_s_Product7__productElement__I__O };
